<template>
  <div>
    <h4 class="mt-4">{{formatDateSimple(day.date)}}</h4>
    <Notification
      v-for="(notification, index) in day.notifications" :key="index"
      :notification="notification"
      :icon="getIcon(notification.eventType)">
    </Notification>
  </div>
</template>
<script>
import { lookupByEventType } from "@/stores/timeline/eventTypes"
import Helpers from '@/helpers.js'
import Notification from '@/components/notifications/Notification'
import { mapState } from "vuex"

export default {
  name: "notification-day",
  components: { Notification },
  props: { day: Object },
  computed: {
    ...mapState({
      dateTimeFormat: state => state.currentUser.me.preferences.dateTimeFormat
    })
  },
  data: () => ({
    notificationIcons: {
      "case.read": {
        icon: "visibility",
        iconClass: "indigo white--text"
      },
      "case.state.changed": {
        icon: "flare",
        iconClass: "blue lighten-1 white--text"
      },
      "case.updated": {
        icon: "cached",
        iconClass: "cyan lighten-1 white--text"
      },
      "case.created": {
        icon: "note_add",
        iconClass: "green lighten-1 white--text"
      },
      "case.deleted": {
        icon: "remove_circle",
        iconClass: "red lighten-1 white--text" // NEW
      },
      "task.created": {
        icon: "check",
        iconClass: "orange darken-1 white--text"
      },
      "task.updated": {
        icon: "check",
        iconClass: "orange darken-1 white--text"
      },
      "task.deleted": {
        icon: "close",
        iconClass: "red lighten-1 white--text" // NEW
      },
      "task.executed": {
        icon: "check",
        iconClass: "orange darken-1 white--text"
      },
      "tasklist.created": {
        icon: "check",
        iconClass: "orange darken-1 white--text"
      },
      "tasklist.updated": {
        icon: "check",
        iconClass: "orange darken-1 white--text" // NEW
      },
      "tasklist.deleted": {
        icon: "close",
        iconClass: "red lighten-1 white--text" // NEW
      },
      "document.uploaded": {
        icon: "description",
        iconClass: "pink darken-2 white--text"
      },
      "document.updated": {
        icon: "description",
        iconClass: "pink darken-2 white--text"
      },
      "document.deleted": {
        icon: "description",
        iconClass: "pink darken-2 white--text"
      },
      "document.viewed": {
        icon: "description",
        iconClass: "pink darken-2 white--text"
      },
      "document.downloaded": {
        icon: "description",
        iconClass: "pink darken-2 white--text"
      },
      "document.duplicated": {
        icon: "description",
        iconClass: "pink darken-2 white--text"
      },
      "document.copied": {
        icon: "description",
        iconClass: "pink darken-2 white--text"
      },
      "document.moved": {
        icon: "description",
        iconClass: "pink darken-2 white--text"
      },
      "case.note.created": {
        icon: "note_add",
        iconClass: "green lighten-1 white--text"
      },
      "case.note.updated": {
        icon: "cached",
        iconClass: "cyan lighten-1 white--text"
      },
      "case.note.deleted": {
        icon: "remove_circle",
        iconClass: "red lighten-1 white--text"
      },
      "conversation.received": {
        icon: "message",
        iconClass: "orange darken-2 white--text" // New
      },
      "conversation.created": {
        icon: "message",
        iconClass: "orange darken-2 white--text"
      },
      "conversation.replied": {
        icon: "reply",
        iconClass: "blue darken-2 white--text"
      },
      "conversation.read": {
        icon: "message",
        iconClass: "orange darken-2 white--text"
      },
      "conversation.attached": {
        icon: "attach_file",
        iconClass: "orange darken-2 white--text"
      },
      email_reply_received: {
        icon: "reply",
        iconClass: "blue darken-2 white--text"
      },
      email_receive_failed: {
        icon: "error",
        iconClass: "red darken-2 white--text"
      },
      email_receive_recovered: {
        icon: "check_circle",
        iconClass: "green darken-2 white--text"
      },
      reindex_started: {
        icon: "autorenew",
        iconClass: "orange darken-2 white--text" // New
      },
      reindex_finished: {
        icon: "autorenew",
        iconClass: "orange darken-2 white--text" // New
      },
      reindex_failed: {
        icon: "error",
        iconClass: "red darken-2 white--text"
      },
      export_started: {
        icon: "import_export",
        iconClass: "orange darken-2 white--text" // New
      },
      export_batch_progress: {
        icon: "import_export",
        iconClass: "orange darken-2 white--text" // New
      },
      export_finished: {
        icon: "import_export",
        iconClass: "orange darken-2 white--text" // New
      },
      import_started: {
        icon: "import_export",
        iconClass: "orange darken-2 white--text" // New
      },
      import_finished: {
        icon: "import_export",
        iconClass: "orange darken-2 white--text" // New
      },
      error: {
        icon: "close",
        iconClass: "red darken-2 white--text" // New
      },
      "timeline.custom": {
        icon: "timeline",
        iconClass: "orange darken-1 white--text"
      },
      default: {
        icon: "timeline",
        iconClass: "grey lighten-1 white--text"
      }
    }
  }),
  methods: {
    formatDateSimple(date) { return Helpers.formatEventDateSimple(date) },
    getIcon(type) {
      const entry = lookupByEventType(this.notificationIcons, type) || this.notificationIcons.default
      return entry.icon
    }
  }
}
</script>

<style>

</style>
